'use strict';

const forgeUiComponent = require('../framework/ui-component');

const BffLogo = forgeUiComponent('BFFLogo', {
  minimized: 'is-minimized'
});

module.exports = BffLogo;
